const styles = {
  container: {
    fontFamily: "Inter Tight",
    padding: "0 .5vw",
  },
  heading: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: 500,
  },
  sub_heading: {
    color: "#0D0D0E",
    fontSize: "15px",
    fontWeight: 500,
  },
  text: {
    color: "#949DAA",
    fontSize: "15px",
    fontWeight: 400,
    lineHeight: "24px",
    letterSpacing: "0.25px",
  },
  small_sub_heading: {
    color: "#0D0D0E",
    fontSize: "14px",
    fontWeight: 500,
  },
  small_text: {
    color: "#949DAA",
    fontSize: "14px",
    fontWeight: 400,
    textTransform: "capitalize",
  },
  columnFlex: {
    display: "flex",
    flexDirection: "column",
    gap: "10px",
  },
  rowFlex: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    gap: "10px",
  },
  budgetContainer: {
    paddingLeft: "2vw",
    borderRadius: "8px",
    marginTop: "1vh",
  },
  budgetRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "1vh 1vw",
    borderRadius: "12px",
    background: " #F7F7F7",
    flex: 1,
  },
  //first row
  idText: {
    fontSize: "12px",
    color: "#0D0D0E",
  },
  idLabel: {
    color: "#949DAA",
    fontSize: "14px",
  },
  startDate: {
    fontSize: "14px",
    color: "#0D0D0E",
  },
  endDate: {
    fontSize: "14px",
    color: "#949DAA",
  },
  projectHeading: {
    color: "#0D0D0E",
    fontSize: "22px",
    fontWeight: "500",
  },
  price: {
    color: "#0D0D0E",
    fontSize: "18px",
    fontWeight: "500",
    textTransform: "capitalize",
  },
};

export default styles;
